import React from 'react'

import { useCommonTx } from '~/hooks/useTranslationForNamespace'
import QuoteIcon from '~/images/Landing/quote-icon.svg'

export const StatsAndReviews = () => {
  const t = useCommonTx('landing.statsAndReviews')
  const yearsSinceFounded = new Date().getFullYear() - 2007

  return (
    <div className='flex flex-col items-center justify-center text-center gap-8 flex-wrap px-10 py-[8%] w-full'>
      <div className='text-title-1 font-bold font-serif'>{t('header', { years: yearsSinceFounded })}</div>
      <div className='flex flex-col md:flex-row gap-4 justify-center w-full max-w-[800px]'>
        <Review>
          <QuoteIconContainer>
            <QuoteIcon title='quote' />
          </QuoteIconContainer>
          <div className='text-body-text-1'>{t('review1')}</div>
          <div className='text-micro-text-1 uppercase text-text-interactive'>
            {t('reviewerNameNewJersey', { name: 'Mary' })}
          </div>
        </Review>
        <Review>
          <QuoteIconContainer>
            <QuoteIcon title='quote' />
          </QuoteIconContainer>
          <div className='text-body-text-1'>{t('review2')}</div>
          <div className='text-micro-text-1 uppercase text-text-interactive'>
            {t('reviewerNameCalifornia', { name: 'Rashmi' })}
          </div>
        </Review>
      </div>
    </div>
  )
}

const QuoteIconContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className='self-start text-[3em]'>{children}</div>
}

const Review = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='flex flex-col gap-7 text-left bg-[#FFFBF7] rounded-2xl basis-[50%] border border-solid border-[#E8E6E3] py-[60px] px-[40px] aspect-square'>
      {children}
    </div>
  )
}
